import { createRouter, createWebHistory } from 'vue-router';
import { authState, bootstrapAuth } from '../stores/auth';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: () => import('../views/LoginView.vue') },
    { path: '/', name: 'channels', component: () => import('../views/ChannelsView.vue') },
  ],
});

let authChecked = false;

router.beforeEach(async (to) => {
  if (!authChecked) {
    await bootstrapAuth();
    authChecked = true;
  }

  if (to.name !== 'login' && !authState.secret) {
    return { name: 'login' };
  }
  if (to.name === 'login' && authState.secret) {
    return { name: 'channels' };
  }
  return true;
});

export { router };
